



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import criticalLabResultService from "@/services/criticalLabResultService";

@Component
export default class PeriodicReportTabs extends Vue {
  @Prop({ default: "" }) tanggal!: string;
  @Prop({ default: "" }) unitLab!: string;

  periods: any = {};

  get periodeList() {
    return [
      { key: "harian", label: "Harian", data: this.periods.harian },
      { key: "bulanan", label: "Bulanan", data: this.periods.bulanan },
      { key: "triwulan", label: "Triwulan", data: this.periods.triwulan },
      { key: "semester", label: "6 Bulanan (Semester)", data: this.periods.semester },
      { key: "tahunan", label: "Tahunan", data: this.periods.tahunan },
    ];
  }

  @Watch("tanggal", { immediate: true })
  onTanggalChange() {
    if (this.tanggal) this.loadPeriods();
  }

  async loadPeriods() {
    try {
      const res = await criticalLabResultService.getAllPeriods({
        tanggal: this.tanggal,
        unit_laboratorium: this.unitLab || undefined,
      });
      this.periods = res.data?.data || {};
    } catch (e) {
      console.error(e);
    }
  }
}
